import { onBeforeUnmount, ref, type Ref } from 'vue'

function readsReduced(query: MediaQueryList | undefined): boolean {
  return query?.matches ?? false
}

/** jsdom in component tests carries no real matchMedia; this degrades to "not reduced". */
function reducedMotionQuery(): MediaQueryList | undefined {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)')
  } catch {
    return undefined
  }
}

export function usePrefersReducedMotion(): Ref<boolean> {
  const query = reducedMotionQuery()
  const prefersReduced = ref(readsReduced(query))
  const onChange = (event: MediaQueryListEvent): void => {
    prefersReduced.value = event.matches
  }
  query?.addEventListener('change', onChange)
  onBeforeUnmount(() => query?.removeEventListener('change', onChange))
  return prefersReduced
}
